import { RelativeMedicalLetterDto } from '../persons/dto/relative-medical-letter-dto';

export class MedicalLetterDto {
    Id: number;
    EmployeeId: string;
    RequestDate: Date;
    Relatives: RelativeMedicalLetterDto;
    MedicalLetterTypes: number[];
    Observations: string;
    ShiftId: number;
    TypeEmployeeId: number;
    constructor() {
        this.Id = -1;
        this.RequestDate = new Date();
        this.EmployeeId = '-1';
        this.Relatives = new RelativeMedicalLetterDto();
        this.MedicalLetterTypes = [];
        this.ShiftId = -1;
        this.TypeEmployeeId = -1;
        this.Observations = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/medical-letter/medical-letter-dto.ts